<template>
  <v-dialog :value="value" max-width="900" @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="pdf-title">Vista previa de transporte<v-spacer />
        <v-btn icon :disabled="!listo" title="Imprimir" aria-label="Imprimir" @click="imprimir"><v-icon>mdi-printer</v-icon></v-btn>
        <v-btn icon :disabled="!url" :href="url || undefined" download="transporte.pdf" title="Descargar PDF" aria-label="Descargar PDF"><v-icon>mdi-download</v-icon></v-btn>
        <v-btn icon title="Cerrar" aria-label="Cerrar" @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-progress-linear v-if="cargando || url && !listo && !fallo" indeterminate />
      <v-alert v-if="error || fallo" type="error" outlined class="ma-4">{{ error || fallo }}</v-alert>
      <div v-if="url" class="pdf-paper"><vue-pdf-embed ref="pdf" :source="url" @rendered="listo = true" @loading-failed="falloPdf" @rendering-failed="falloPdf" /></div>
      <div v-else class="pdf-empty">{{ cargando ? 'Generando PDF...' : '' }}</div>
    </v-card>
  </v-dialog>
</template>
<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
export default {
  components: { VuePdfEmbed },
  props: { value: Boolean, blob: Blob, cargando: Boolean, error: String },
  data: () => ({ url: '', listo: false, fallo: '' }),
  watch: { blob() { this.cargar(); }, value() { this.cargar(); } },
  beforeDestroy() { this.limpiar(); },
  methods: {
    limpiar() { if (this.url) URL.revokeObjectURL(this.url); this.url = ''; this.listo = false; this.fallo = ''; },
    cargar() { this.limpiar(); if (this.value && this.blob) this.url = URL.createObjectURL(this.blob); },
    falloPdf() { this.fallo = 'No se pudo mostrar el PDF. Puede descargarlo para imprimirlo.'; },
    async imprimir() {
      try { await this.$refs.pdf.print(203, 'transporte.pdf', true); }
      catch (_) { this.fallo = 'Descargue el PDF y abralo en una aplicacion compatible para imprimirlo.'; }
    },
  },
};
</script>
<style scoped>
.pdf-title { font-size: 17px; line-height: 1.4; flex-wrap: wrap; }
.pdf-paper { height: 72vh; overflow: auto; padding: 16px; background: #525659; }
.pdf-paper > div { width: 100%; max-width: 420px; margin: 0 auto; }
.pdf-empty { min-height: 180px; display: flex; align-items: center; justify-content: center; }
</style>
